/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';

import { icons, LucideProps } from 'lucide-react';

import { customs } from './customs';

export type IconName = keyof typeof icons | keyof typeof customs;

interface IconProps extends LucideProps {
	name: IconName;
	preferredLibrary?: 'lucide' | 'custom';
}

export function Icon({
	name,
	size = '1em',
	preferredLibrary = 'custom',
	...props
}: IconProps) {
	const LucideIcon = (icons as any)?.[name];
	const CustomIcon = (customs as any)?.[name];

	if (!LucideIcon && !CustomIcon) {
		console.warn(
			`Icon ${name} does not exist in lucide-react package or customs.`,
		);
		return null;
	}

	const IconComponent =
		preferredLibrary === 'custom'
			? ((CustomIcon || LucideIcon) as React.FC<LucideProps>)
			: ((LucideIcon || CustomIcon) as React.FC<LucideProps>);

	return (
		<IconComponent
			{...props}
			style={{
				width: size,
				height: size,
				objectFit: 'contain',
				...props.style,
			}}
		/>
	);
}

export default memo(Icon);
